<template>
  <div class="companyInformation">
    <!-- 公司信息 -->
    <div class="service">
      <div class="service-img">
        <div>就现在，按下企业数字化升级的加速键</div>
        <div class="btn">
          <van-button plain type="info" @click="handleOpenPractice"
            >开始体验</van-button
          >
        </div>
      </div>
      <div class="service-footer">
        <div class="service-contact-information">
          <div>
            <img src="../../assets/img/phoneHomePage/service-phone.png" />
            <div>服务热线：400-600-7966</div>
          </div>
          <div>
            <img
              src="../../assets/img/phoneHomePage/service-address.png"
              style="margin-right: 8px; height: 14px"
            />
            <div>公司地址：山东省济南市高新区天辰路1571号金现代大厦</div>
          </div>
        </div>
        <div class="service-divider">
          <van-divider :style="{ borderColor: '#585858' }" />
        </div>
        <div class="service-record">
          <div>© 2016-2022 金现代信息产业股份有限公司</div>
          <div>鲁ICP备09033671</div>
          <div>鲁公网安备 37010102000748号</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompanyInformation",
  components: {},
  data() {
    return {
    };
  },
  methods: {
    handleOpenPractice() {
      this.$emit('changePracticeMenuShow')
    },
  },
};
</script>
<style scoped>
/* 公司信息 */
.service-img {
  background: url("../../assets/img/phoneHomePage/service-bg.png") no-repeat;
  height: 145px;
  background-size: cover;
}
.service-img > div {
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  padding-top: 40px;
}
.service-img > .btn {
  padding-top: 15px !important;
}
.service-footer {
  background: #2e2e2e;
  height: 260px;
  padding-bottom: 40px;
}
.service-contact-information > div {
  display: flex;
  padding: 15px 20px 0 20px;
}
.service-contact-information > div > img {
  height: 13px;
  margin-right: 5px;
}
.service-contact-information > div > div {
  line-height: 20px;
  font-size: 16px;
  color: #eee;
}
.service-divider {
  justify-content: center;
  display: flex;
}
.service-divider .van-divider {
  width: 90%;
  color: #67707d;
}
.service-record {
  padding-left: 20px;
}
.service-record > div {
  padding-top: 2px;
  color: #67707d;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/include/CompanyInformation.vue